// extracted by mini-css-extract-plugin
export default {"fullScreenLoader_container":"Loaders_fullScreenLoader_container__F6G34","logo_container":"Loaders_logo_container__gOUmv","logo_text":"Loaders_logo_text__yq8d3"};